// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1YtUN","container":"styles_container__1vjGw","title":"styles_title__3QRiA","wrapper":"styles_wrapper__aWaQ3","answer":"styles_answer__2_0yj"};